// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"87":"13ad349a","123":"5fb03e6e","207":"3fb4bfd1","923":"44626fb8","936":"2756fb97"}[chunkId] + ".js";
};